import { render, staticRenderFns } from "./IconPause.vue?vue&type=template&id=b0e6a0c0&"
import script from "./IconPause.vue?vue&type=script&lang=js&"
export * from "./IconPause.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0e6a0c0')) {
      api.createRecord('b0e6a0c0', component.options)
    } else {
      api.reload('b0e6a0c0', component.options)
    }
    module.hot.accept("./IconPause.vue?vue&type=template&id=b0e6a0c0&", function () {
      api.rerender('b0e6a0c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconPause.vue"
export default component.exports